import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import Select from "react-select";

function AddSubAccountMaster() {
  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const routeLocation = useLocation();
  const [loadingFull, setLoadingFull] = useState(false);
  const [gstList, setGstList] = useState([]);
  const [addrList, setAddrList] = useState([]);
  const [schemeList, setSchemeList] = useState([]);
  const [tcsList, setTcsList] = useState([]);


  const [editId, setEditId] = useState(null);
  const [accountCodes, setAccountCodes] = useState([]);
  const [partyNatures, setPartyNatures] = useState([]);
  const [partyTypes, setPartyTypes] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [tabsVisible, setTabsVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("GST");
  const [gstTypes, setGstTypes] = useState([]);
  const [states, setStates] = useState([]);
  const [addrCities, setAddrCities] = useState([]);
  const [tcsCities, setTcsCities] = useState([]);
  const [currentSubId, setCurrentSubId] = useState(null);

  // ---------- MAIN FORM ----------
  const [form, setForm] = useState({
    sub_account_id: "",
    account_code: "",
    party_nature: "",
    party_name: "",
    aadhar_no: "",
    pan: "",
    party_code: "",
    party_type: "",
    is_active: "",
    opening_balance: "",
  });
  const clearGstForm = () => setGstForm(emptyGstForm);
  const clearAddrForm = () => setAddrForm(emptyAddrForm);
  const clearSchemeForm = () => setSchemeForm(emptySchemeForm);
  const clearTcsForm = () => setTcsForm(emptyTcsForm);

  // ---------- GST FORM ----------
  // const [gstForm, setGstForm] = useState({
  //   sub_gst_details_id: 0,
  //   gst_type_id: "",
  //   state_id: "",
  //   gst_reg_no: "",
  //   gst_reg_date: "",
  //   prov_reg_no: "",
  //   prov_reg_date: "",
  // });

  // // ---------- ADDRESS FORM ----------
  // const [addrForm, setAddrForm] = useState({
  //   sub_address_details_id: 0,
  //   state_id: "",
  //   city_id: "",
  //   address1: "",
  //   address2: "",
  //   address3: "",
  //   pincode: "",
  //   contact1: "",
  //   contact2: "",
  //   email: "",
  //   contact_person1: "",
  //   contact_person2: "",
  // });

  // // ---------- GST SCHEME FORM ----------
  // const [schemeForm, setSchemeForm] = useState({
  //   sub_scheme_details_id: 0,
  //   scheme_id: "",
  //   eff_from: "",
  //   eff_to: "",
  // });

  // // ---------- TCS FORM ----------
  // const [tcsForm, setTcsForm] = useState({
  //   sub_tcs_details_id: 0,
  //   state_id: "",
  //   city_id: "",
  //   tcs_no: "",
  //   tcs_date: "",
  // });
  const emptyGstForm = {
    sub_gst_details_id: 0,
    gst_type_id: "",
    state_id: "",
    gst_reg_no: "",
    gst_reg_date: "",
    prov_reg_no: "",
    prov_reg_date: "",
  };

  const emptyAddrForm = {
    sub_address_details_id: 0,
    state_id: "",
    city_id: "",
    address1: "",
    address2: "",
    address3: "",
    pincode: "",
    contact1: "",
    contact2: "",
    email: "",
    contact_person1: "",
    contact_person2: "",
  };

  const emptySchemeForm = {
    sub_scheme_details_id: 0,
    scheme_id: "",
    eff_from: "",
    eff_to: "",
  };

  const emptyTcsForm = {
    sub_tcs_details_id: 0,
    state_id: "",
    city_id: "",
    tcs_no: "",
    tcs_date: "",
  };

  // ---------- DEFAULT SEARCH PAYLOAD FOR /searchsubaccount ----------
  const defaultSearchPayload = {
    account_master_id: "",
    party_code: "",
    party_name: "",
    active: "",
    party_type_id: "",
    party_nature_id: "",
    party_gst_type_id: "",
    party_state_id: "",
    party_gst_registration_no: "",
    party_provisional_registration_no: "",
    aadhar_number: "",
    pan_number: "",
  };
  // GST FORM
  const [gstForm, setGstForm] = useState(emptyGstForm);

  // ADDRESS FORM
  const [addrForm, setAddrForm] = useState(emptyAddrForm);

  // GST SCHEME FORM
  const [schemeForm, setSchemeForm] = useState(emptySchemeForm);

  // TCS FORM
  const [tcsForm, setTcsForm] = useState(emptyTcsForm);

  useEffect(() => {
    const state = routeLocation.state;

    // ID could be passed as subAccountId or legacy SubAccountData
    const idFromState =
      state?.subAccountId ||
      state?.SubAccountData?.sub_account_id ||
      state?.SubAccountData?.sub_account_master_id;

    if (!idFromState) return;

    setEditId(idFromState);
    setCurrentSubId(idFromState);
    setTabsVisible(true);

    // Fetch full details from backend
    fetchFullSubAccount(idFromState);
  }, [routeLocation]);


  // ---------- MASTER DATA FETCHES ----------
  const fetchAccountCodes = async () => {
    try {
      const resp = await axios.get(
        baseUrl + "/get_accountcode_byaccountnature_sub_none/",
        {
          params: {
            _flag: 2,
          },
        }
      );
      setAccountCodes(resp.data || []);
    } catch (e) {
      console.error(e);
      toast.error("Failed to load account codes");
    }
  };

  const fetchPartyNatures = async () => {
    try {
      const resp = await axios.get(baseUrl + "/get_party_nature/");
      setPartyNatures(resp.data || []);
    } catch (e) {
      console.error(e);
      toast.error("Failed to load party nature list");
    }
  };

  const fetchPartyTypes = async () => {
    try {
      const resp = await axios.get(baseUrl + "/get_party_type/");
      setPartyTypes(resp.data || []);
    } catch (e) {
      console.error(e);
      toast.error("Failed to load party type list");
    }
  };

  useEffect(() => {
    fetchAccountCodes();
    fetchPartyNatures();
    fetchPartyTypes();
  }, []);

  useEffect(() => {
    if (!tabsVisible) return;
    const load = async () => {
      try {
        if (!gstTypes.length) {
          const g = await axios.get(baseUrl + "/get_party_gst_type/");
          setGstTypes(g.data || []);
        }
        if (!states.length) {
          const s = await axios.post(
            baseUrl + "/states/",
            {
              action: "READ",
            },
            {
              headers: { "Content-Type": "application/json" },
            }
          );
          setStates(s.data || []);
        }
      } catch (e) {
        console.error(e);
      }
    };
    load();
  }, [tabsVisible, gstTypes.length, states.length, baseUrl]);

  // ---------- OPTIONS ----------
  const accountCodeOptions = useMemo(
    () =>
      (accountCodes || []).map((it) => {
        const name = it.name_on_account ?? it.account_name ?? it.name ?? "";
        return {
          value: it.account_master_id ?? it.account_id ?? it.accountmaster_id,
          label: name,
          _id: it.account_master_id ?? it.account_id ?? it.accountmaster_id,
        };
      }),
    [accountCodes]
  );

  const partyNatureOptions = useMemo(
    () =>
      (partyNatures || [])
        .filter((n) => (n.is_active || "Active") === "Active")
        .map((n) => {
          const name = n.party_nature_name ?? n.party_nature ?? n.nature ?? "";
          return { value: name, label: name, _id: n.party_nature_id };
        }),
    [partyNatures]
  );

  const partyTypeOptions = useMemo(
    () =>
      (partyTypes || [])
        .filter((t) => (t.is_active || "Active") === "Active")
        .map((t) => {
          const name = t.party_type_name ?? t.party_type ?? t.type ?? "";
          return { value: name, label: name, _id: t.party_type_id };
        }),
    [partyTypes]
  );

  const stateOptions = useMemo(
    () =>
      (states || []).map((s) => ({
        value: s.state_id ?? s.stateid,
        label: s.state_name ?? s.statename,
      })),
    [states]
  );

  const gstTypeOptions = useMemo(
    () =>
      (gstTypes || []).map((g) => ({
        value: g.party_gst_type_id,
        label: g.party_gst_name,
      })),
    [gstTypes]
  );

  const addrCityOptions = useMemo(
    () =>
      (addrCities || []).map((c) => ({
        value: c.cityid,
        label: c.cityname,
      })),
    [addrCities]
  );

  const tcsCityOptions = useMemo(
    () =>
      (tcsCities || []).map((c) => ({
        value: c.cityid,
        label: c.cityname,
      })),
    [tcsCities]
  );

  const natureIsParty =
    form.party_nature &&
    form.party_nature.toString().trim().toLowerCase() === "party";

  const numberOrZero = (v) => {
    const n = parseFloat(String(v).replace(/,/g, ""));
    return Number.isFinite(n) ? n : 0;
  };

  // ---------- COMMON HELPERS ----------
  const handleAccountCodeChange = async (opt) => {
    setForm((f) => ({ ...f, account_code: opt ? opt.value : "" }));
  };

  const handleAadharBlur = async () => {
    if (!natureIsParty || !form.aadhar_no?.trim()) return;
    try {
      const resp = await axios.post(
        baseUrl + "/get_party_by_aadhar_pan/",
        { aadhar_number: form.aadhar_no.trim(), pan_number: null },
        { headers: { "Content-Type": "application/json" } }
      );
      if (resp.status === 200 && resp.data) {
        toast.warning("Record already exists with the same aadhar");
        setForm((f) => ({
          ...f,
          aadhar_no: "",
        }));
      }
    } catch (e) {
      if (e.response && e.response.status === 404) return;
      console.error(e);
      toast.error("Party details can't be loaded");
    }
  };

  const handlePanBlur = async () => {
    if (!natureIsParty || !form.pan?.trim()) return;
    try {
      // Implement PAN duplicate check here if needed
    } catch (e) {
      console.error(e);
    }
  };

  const fetchCitiesByState = async (stateId, setFn) => {
    if (!stateId) {
      setFn([]);
      return;
    }
    try {
      const resp = await axios.get(baseUrl + "/getcity", {
        params: { _state_id: stateId },     // matches FastAPI param name
        headers: { "Content-Type": "application/json" },
      });
      setFn(resp.data || []);
    } catch (e) {
      console.error(e);
      setFn([]);
    }
  };


  const fetchPartyCodeFromSearch = async (subAccountId) => {
    try {
      const response = await axios.get(baseUrl + "/searchsubaccount/", {
        params: defaultSearchPayload, // DON'T pass values, only defaults
        headers: { "Content-Type": "application/json" },
      });

      const data = Array.isArray(response.data) ? response.data : [];

      // Find our newly created record by sub_account_master_id / sub_account_id
      const rec = data.find(
        (row) =>
          row.sub_account_master_id === subAccountId ||
          row.sub_account_master_id === Number(subAccountId) ||
          row.sub_account_id === subAccountId ||
          row.sub_account_id === Number(subAccountId)
      );

      if (rec && rec.party_code) {
        setForm((f) => ({
          ...f,
          party_code: rec.party_code,
        }));
      } else {
        toast.warning("Party Code not found from searchsubaccount");
      }
    } catch (error) {
      console.log("Error fetching Party Code from /searchsubaccount:", error);
      toast.error("Failed to fetch Party Code");
    }
  };

  // ---------- MAIN FORM SUBMIT ----------
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !form.account_code ||
      !form.party_nature ||
      !form.party_name ||
      !form.is_active ||
      (natureIsParty && !form.party_type) ||
      (natureIsParty && !form.aadhar_no)
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    const selAcc = accountCodeOptions.find(
      (o) => o.value === form.account_code
    );
    if (!selAcc || !selAcc._id) {
      toast.error("Invalid Account Code selection");
      return;
    }

    const selNature = partyNatureOptions.find(
      (o) => o.value === form.party_nature
    );
    if (!selNature || !selNature._id) {
      toast.error("Invalid Party Nature selection");
      return;
    }

    const selType = natureIsParty
      ? partyTypeOptions.find((o) => o.value === form.party_type)
      : null;

    const createdBy =
      userObj?.username ||
      userObj?.user_name ||
      userObj?.login_id ||
      userObj?.email_id ||
      userObj?.email ||
      "";

    const payload = {
      sub_account_master_id: editId || 0,
      account_master_id: selAcc._id,
      party_code: form.party_code || null,
      party_name: form.party_name?.trim(),
      party_type_id: natureIsParty && selType ? selType._id : null,
      party_nature_id: selNature._id,
      aadhar_number: natureIsParty ? form.aadhar_no?.trim() : null,
      pan_number: natureIsParty ? form.pan?.trim() : null,
      active: form.is_active === "A",
      created_by: createdBy,
      opening_balance: numberOrZero(form.opening_balance),
    };

    try {
      setIsSaving(true);
      const resp = await axios.post(
        baseUrl + "/addupdatesub_account_master/",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      const op = resp.data?.operation || (editId ? "updated" : "created");
      const newId = resp.data?.sub_account_master_id;
      toast.success(
        op === "updated"
          ? "Record Updated Successfully"
          : "Record Added Successfully",
        { position: "top-right" }
      );

      if (newId) {
        setEditId(newId);
        setCurrentSubId(newId);
      }
      setTabsVisible(true);

      // INITIAL CREATE: DON'T CLEAR FIELDS, JUST FETCH PARTY CODE
      if (!editId && newId) {
        await fetchPartyCodeFromSearch(newId);
      }
      // For update, keep form as-is.
    } catch (error) {
      console.error("Submit error:", error);
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400)
          toast.error(data?.error || "Validation error", {
            position: "top-right",
          });
        else if (status === 500)
          toast.error("Server error: " + (data?.error || error.message), {
            position: "top-right",
          });
        else
          toast.error("Unexpected error occurred", {
            position: "top-right",
          });
      } else
        toast.error("Network error: " + error.message, {
          position: "top-right",
        });
    } finally {
      setIsSaving(false);
    }
  };

  // ---------- GST SAVE (WITH DUPLICATE CHECK) ----------
  const handleGstSave = async () => {
    if (!currentSubId) {
      toast.error("Please save the Sub Account first");
      return;
    }

    if (!gstForm.gst_type_id || !gstForm.state_id) {
      toast.error("Please select Party GST Type and Party State");
      return;
    }

    try {
      const checkResp = await axios.get(
        `${baseUrl}/check_subaccountparty_gst_partystate/`,
        {
          params: {
            _sub_account_master_id: currentSubId,
            _party_state_id: gstForm.state_id,
            _sub_gst_details_id: gstForm.sub_gst_details_id || 0,
          },
        }
      );

      if (checkResp.data?.duplicate_exists) {
        toast.error(
          "GST details already exist for this Sub Account and State. Duplicate not allowed."
        );
        return;
      }
    } catch (err) {
      if (err.response && err.response.status === 404) {
        // no duplicate, continue
      } else {
        console.error("Duplicate check error:", err);
        toast.error("Failed to validate GST details");
        return;
      }
    }

    // 🔹 same logic you used in handleSubmit
    const createdBy =
      userObj?.username ||
      userObj?.user_name ||
      userObj?.login_id ||
      userObj?.email_id ||
      userObj?.email ||
      "";

    const payload = {
      sub_gst_details_id: gstForm.sub_gst_details_id || 0,
      sub_account_master_id: currentSubId,
      party_gst_type_id: gstForm.gst_type_id,
      party_state_id: gstForm.state_id,
      party_gst_registration_no: gstForm.gst_reg_no || null,
      party_provisional_registration_no: gstForm.prov_reg_no || null,
      gst_registration_date: gstForm.gst_reg_date || null,
      provisional_registration_date: gstForm.prov_reg_date || null,
      created_by: createdBy,              // 🔸 required by FastAPI
    };

    try {
      const resp = await axios.post(
        `${baseUrl}/addupdatesubaccountmasterdetailsgst/`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      const op =
        resp.data?.operation ||
        (gstForm.sub_gst_details_id ? "updated" : "created");

      toast.success(
        op === "updated"
          ? "GST details updated successfully"
          : "GST details saved successfully"
      );

      // 👉 reload grid
      await fetchFullSubAccount(currentSubId);

      // 👉 clear form for new entry
      setGstForm(emptyGstForm);
    } catch (err) {
      console.error("GST save error:", err);
      toast.error("Failed to save GST details");
    }

  };


  // ---------- ADDRESS SAVE ----------
  const handleAddressSave = async () => {
    if (!currentSubId) {
      toast.error("Please save the Sub Account first");
      return;
    }

    if (!addrForm.state_id || !addrForm.city_id) {
      toast.error("Please select State and City for address");
      return;
    }

    const payload = {
      sub_address_details_id: addrForm.sub_address_details_id || 0,
      sub_account_master_id: currentSubId,
      state_id: addrForm.state_id,
      city_id: addrForm.city_id,
      address1: addrForm.address1 || null,
      address2: addrForm.address2 || null,
      address3: addrForm.address3 || null,
      pincode: addrForm.pincode || null,
      contact_person1: addrForm.contact1 || null,
      contact_person2: addrForm.contact2 || null,
      email: addrForm.email || null,
      contact_person_name1: addrForm.contact_person1 || null,
      contact_person_name2: addrForm.contact_person2 || null,
      created_by: userObj.user_name
    };

    try {
      const resp = await axios.post(
        `${baseUrl}/addupdatesub_address_details/`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      const op =
        resp.data?.operation ||
        (addrForm.sub_address_details_id ? "updated" : "created");
      const newId = resp.data?.sub_address_details_id;

      if (newId) {
        setAddrForm((f) => ({
          ...f,
          sub_address_details_id: newId,
        }));
      }

      toast.success(
        op === "updated"
          ? "Address details updated successfully"
          : "Address details saved successfully"
      );
     

      // 👉 reload list and clear form
      await fetchFullSubAccount(currentSubId);
      setAddrForm(emptyAddrForm);

    } catch (err) {
      console.error("Address save error:", err);
      toast.error("Failed to save Address details");
    }
  };

  // ---------- GST SCHEME SAVE ----------
  const handleSchemeSave = async () => {
    if (!currentSubId) {
      toast.error("Please save the Sub Account first");
      return;
    }

    if (!schemeForm.scheme_id) {
      toast.error("Please select GST Scheme");
      return;
    }

    const payload = {
      sub_scheme_details_id: schemeForm.sub_scheme_details_id || 0,
      sub_account_master_id: currentSubId,
      gst_scheme_id: schemeForm.scheme_id,
      effective_date_from: schemeForm.eff_from || null,
      effective_date_to: schemeForm.eff_to || null,
      created_by: userObj.user_name
    };

    try {
      const resp = await axios.post(
        `${baseUrl}/addupdatesub_scheme_details/`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      const op =
        resp.data?.operation ||
        (schemeForm.sub_scheme_details_id ? "updated" : "created");
      const newId = resp.data?.sub_scheme_details_id;

      if (newId) {
        setSchemeForm((f) => ({
          ...f,
          sub_scheme_details_id: newId,
        }));
      }

      toast.success(
        op === "updated"
          ? "GST Scheme details updated successfully"
          : "GST Scheme details saved successfully"
      );
      await fetchFullSubAccount(currentSubId);
      setSchemeForm(emptySchemeForm);
    } catch (err) {
      console.error("GST Scheme save error:", err);
      toast.error("Failed to save GST Scheme details");
    }
  };

  // ---------- TCS SAVE ----------
  const handleTcsSave = async () => {
    if (!currentSubId) {
      toast.error("Please save the Sub Account first");
      return;
    }

    if (!tcsForm.state_id || !tcsForm.city_id || !tcsForm.tcs_no || !tcsForm.tcs_date) {
      toast.error("Please fill all required fields in TCS");
      return;
    }

    const payload = {
      sub_tcs_details_id: tcsForm.sub_tcs_details_id || 0,
      sub_account_master_id: currentSubId,
      state_id: tcsForm.state_id,
      city_id: tcsForm.city_id,
      tcs_no: tcsForm.tcs_no,
      tcs_date: tcsForm.tcs_date,
      created_by: userObj.user_name
    };

    try {
      const resp = await axios.post(
        `${baseUrl}/addupdatesub_tcs_details/`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      const op =
        resp.data?.operation ||
        (tcsForm.sub_tcs_details_id ? "updated" : "created");
      const newId = resp.data?.sub_tcs_details_id;

      if (newId) {
        setTcsForm((f) => ({
          ...f,
          sub_tcs_details_id: newId,
        }));
      }

      toast.success(
        op === "updated"
          ? "TCS details updated successfully"
          : "TCS details saved successfully"
      );
      await fetchFullSubAccount(currentSubId);
      setTcsForm(emptyTcsForm);
    } catch (err) {
      console.error("TCS save error:", err);
      toast.error("Failed to save TCS details");
    }
  };
  const fetchFullSubAccount = async (id) => {
    if (!id) return;
    setLoadingFull(true);
    try {
      const resp = await axios.get(baseUrl + "/getfullsubaccount", {
        params: { _id: id },
        headers: { "Content-Type": "application/json" },
      });

      const raw = Array.isArray(resp.data) ? resp.data[0] : resp.data;
      const root = raw?.get_subaccountmaster_full || raw || {};

      const main = root.objsubaccount || {};
      const gstArr = root.lstsubaccount_details_gst || [];
      const addrArr = root.lstsubaccount_details_address || [];
      const schemeArr = root.lstsubaccount_details_scheme || [];
      const tcsArr = root.lstsubaccount_details_tcs || [];

      // 👉 MAIN FORM ONLY
      setForm({
        sub_account_id: main.sub_account_master_id ?? id,
        account_code: main.account_master_id ?? "",
        party_nature: main.party_nature_name ?? main.party_nature ?? "",
        party_name: main.party_name ?? "",
        aadhar_no: main.aadhar_number ?? "",
        pan: main.pan_number ?? "",
        party_code: main.party_code ?? "",
        party_type: main.party_type_name ?? main.party_type ?? "",
        is_active: main.active === true ? "A" : "I",
        opening_balance:
          main.opening_balance !== undefined && main.opening_balance !== null
            ? String(main.opening_balance)
            : "",
      });

      // 👉 SET LISTS FOR GRIDS
      setGstList(gstArr);
      setAddrList(addrArr);
      setSchemeList(schemeArr);
      setTcsList(tcsArr);

      // 👉 KEEP DETAIL FORMS BLANK BY DEFAULT
      setGstForm(emptyGstForm);
      setAddrForm(emptyAddrForm);
      setSchemeForm(emptySchemeForm);
      setTcsForm(emptyTcsForm);

      // Preload city dropdowns if you want (optional)
      if (addrArr[0]?.state_id) {
        await fetchCitiesByState(addrArr[0].state_id, setAddrCities);
      }
      if (tcsArr[0]?.state_id) {
        await fetchCitiesByState(tcsArr[0].state_id, setTcsCities);
      }
    } catch (e) {
      console.error("Error in fetchFullSubAccount:", e);
      toast.error("Failed to load sub account details");
    } finally {
      setLoadingFull(false);
    }
  };

  // GST row edit
  const handleEditGstRow = (row) => {
    setGstForm({
      sub_gst_details_id: row.sub_gst_details_id ?? 0,
      gst_type_id: row.party_gst_type_id ?? "",
      state_id: row.party_state_id ?? "",
      gst_reg_no: row.party_gst_registration_no ?? "",
      gst_reg_date: row.gst_registration_date
        ? String(row.gst_registration_date).slice(0, 10)
        : "",
      prov_reg_no: row.party_provisional_registration_no ?? "",
      prov_reg_date: row.provisional_registration_date
        ? String(row.provisional_registration_date).slice(0, 10)
        : "",
    });
  };

  // Address row edit
  const handleEditAddressRow = async (row) => {
    setAddrForm({
      sub_address_details_id: row.sub_address_details_id ?? 0,
      state_id: row.state_id ?? "",
      city_id: row.city_id ?? "",
      address1: row.address1 ?? "",
      address2: row.address2 ?? "",
      address3: row.address3 ?? "",
      pincode: row.pincode ?? "",
      contact1: row.contact_person1 ?? "",
      contact2: row.contact_person2 ?? "",
      email: row.email ?? "",
      contact_person1: row.contact_person_name1 ?? "",
      contact_person2: row.contact_person_name2 ?? "",
    });

    if (row.state_id) {
      await fetchCitiesByState(row.state_id, setAddrCities);
    }
  };

  // GST Scheme row edit
  const handleEditSchemeRow = (row) => {
    setSchemeForm({
      sub_scheme_details_id: row.sub_scheme_details_id ?? 0,
      scheme_id: row.gst_scheme_id ?? "",
      eff_from: row.effective_date_from
        ? String(row.effective_date_from).slice(0, 10)
        : "",
      eff_to: row.effective_date_to
        ? String(row.effective_date_to).slice(0, 10)
        : "",
    });
  };

  // TCS row edit
  const handleEditTcsRow = async (row) => {
    setTcsForm({
      sub_tcs_details_id: row.sub_tcs_details_id ?? 0,
      state_id: row.state_id ?? "",
      city_id: row.city_id ?? "",
      tcs_no: row.tcs_no ?? "",
      tcs_date: row.tcs_date ? String(row.tcs_date).slice(0, 10) : "",
    });

    if (row.state_id) {
      await fetchCitiesByState(row.state_id, setTcsCities);
    }
  };


  // ---------- RENDER ----------
  return (
    <div className="pageBody" style={{
      maxHeight: "calc(100vh - 80px)", // adjust header height if needed
      overflowY: "auto",
    }}>
      <ToastContainer />
      <Container fluid>
        <Card>
          <Card.Body>
            <form onSubmit={handleSubmit}>
              <Row>
                <Col xs={12}>
                  <h6 className="commonSectionTitle">Add Sub Account</h6>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>
                        Account Code<span className="requiredStar">*</span>
                      </Form.Label>
                      <Select
                        inputId="account_code"
                        classNamePrefix="react-select"
                        placeholder="Select Account Code"
                        isSearchable
                        isClearable
                        value={
                          form.account_code
                            ? accountCodeOptions.find(
                              (o) => o.value === form.account_code
                            )
                            : null
                        }
                        onChange={handleAccountCodeChange}
                        options={accountCodeOptions}
                      />
                    </Form.Group>
                  </div>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>
                        Party Nature<span className="requiredStar">*</span>
                      </Form.Label>
                      <Select
                        inputId="party_nature"
                        classNamePrefix="react-select"
                        placeholder="Select Party Nature"
                        isSearchable
                        isClearable
                        value={
                          form.party_nature
                            ? partyNatureOptions.find(
                              (o) => o.value === form.party_nature
                            )
                            : null
                        }
                        onChange={(opt) =>
                          setForm((f) => ({
                            ...f,
                            party_nature: opt ? opt.value : "",
                            aadhar_no:
                              opt &&
                                opt.value.toString().toLowerCase() === "party"
                                ? f.aadhar_no
                                : "",
                            pan:
                              opt &&
                                opt.value.toString().toLowerCase() === "party"
                                ? f.pan
                                : "",
                            party_type:
                              opt &&
                                opt.value.toString().toLowerCase() === "party"
                                ? f.party_type
                                : "",
                          }))
                        }
                        options={partyNatureOptions}
                      />
                    </Form.Group>
                  </div>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>
                        Party Name<span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        id="party_name"
                        value={form.party_name}
                        placeholder="Enter Party Name"
                        maxLength={80}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            party_name: e.target.value.replace(
                              /[^a-zA-Z0-9 .,()-]/g,
                              ""
                            ),
                          })
                        }
                      />
                    </Form.Group>
                  </div>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>
                        Aadhar
                        {natureIsParty && (
                          <span className="requiredStar">*</span>
                        )}
                      </Form.Label>
                      <Form.Control
                        required={natureIsParty}
                        disabled={!natureIsParty}
                        type="text"
                        id="aadhar_no"
                        value={form.aadhar_no}
                        placeholder="Enter Aadhar"
                        maxLength={14}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            aadhar_no: e.target.value.replace(/[^\d ]/g, ""),
                          })
                        }
                        onBlur={handleAadharBlur}
                      />
                    </Form.Group>
                  </div>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>PAN</Form.Label>
                      <Form.Control
                        disabled={!natureIsParty}
                        type="text"
                        id="pan"
                        value={form.pan}
                        placeholder="Enter PAN"
                        maxLength={10}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            pan: e.target.value
                              .toUpperCase()
                              .replace(/[^A-Z0-9]/g, ""),
                          })
                        }
                        onBlur={handlePanBlur}
                      />
                    </Form.Group>
                  </div>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>
                        Party Code<span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        id="party_code"
                        value={form.party_code}
                        placeholder="Auto / Read-only"
                        disabled
                      />
                    </Form.Group>
                  </div>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>
                        Party Type
                        {natureIsParty && (
                          <span className="requiredStar">*</span>
                        )}
                      </Form.Label>
                      <Select
                        inputId="party_type"
                        classNamePrefix="react-select"
                        placeholder="Select Party Type"
                        isSearchable
                        isClearable
                        isDisabled={!natureIsParty}
                        value={
                          form.party_type
                            ? partyTypeOptions.find(
                              (o) => o.value === form.party_type
                            )
                            : null
                        }
                        onChange={(opt) =>
                          setForm((f) => ({
                            ...f,
                            party_type: opt ? opt.value : "",
                          }))
                        }
                        options={partyTypeOptions}
                      />
                    </Form.Group>
                  </div>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>
                        Active<span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Select
                        id="is_active"
                        value={form.is_active}
                        required
                        onChange={(e) =>
                          setForm({ ...form, is_active: e.target.value })
                        }
                      >
                        <option value="" disabled hidden>Select</option>
                        <option value="A">Active</option>
                        <option value="I">InActive</option>
                      </Form.Select>
                    </Form.Group>
                  </div>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>Opening Balance</Form.Label>
                      <Form.Control
                        type="text"
                        id="opening_balance"
                        maxLength={150}
                        value={form.opening_balance}
                        placeholder="0.00"
                        inputMode="decimal"
                        onChange={(e) => {
                          const raw = e.target.value.replace(/[^0-9.]/g, "");
                          const normalized = raw
                            .split(".")
                            .reduce(
                              (a, p, i) =>
                                i === 0 ? p : a + (i === 1 ? "." : "") + p,
                              ""
                            );
                          setForm({ ...form, opening_balance: normalized });
                        }}
                      />
                    </Form.Group>
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-between mt-3">
                <div>
                  <Button
                    type="button"
                    variant="primary"
                    className="btn-info clearBtn"
                    onClick={() =>
                      setForm({
                        sub_account_id: "",
                        account_code: "",
                        party_nature: "",
                        party_name: "",
                        aadhar_no: "",
                        pan: "",
                        party_code: "",
                        party_type: "",
                        is_active: "",
                        opening_balance: "",
                      })
                    }
                  >
                    Reset
                  </Button>
                </div>
                <div>
                  <Button
                    type="button"
                    variant="primary"
                    className="btn-danger secondaryBtn me-2"
                    onClick={() => window.history.back()}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                   
                    variant="primary"
                    className="btn-success primaryBtn"
                  >
                  submit
                  </Button>
                </div>
              </div>
            </form>

            {tabsVisible && currentSubId && (
              <div className="mt-4">
                <ul className="nav nav-tabs">
                  {["GST", "Address", "GST Scheme", "TCS"].map((t) => (
                    <li className="nav-item" key={t}>
                      <button
                        type="button"
                        className={
                          "nav-link" + (activeTab === t ? " active" : "")
                        }
                        onClick={() => setActiveTab(t)}
                      >
                        {t}
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="border p-3">
                  {activeTab === "GST" && (
                    <>
                      <Form>
                        <Row>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>
                                  Party GST Type
                                  <span className="requiredStar">*</span>
                                </Form.Label>
                                <Select
                                  classNamePrefix="react-select"
                                  placeholder="--Select GST Type--"
                                  value={
                                    gstForm.gst_type_id
                                      ? gstTypeOptions.find(
                                        (o) => o.value === gstForm.gst_type_id
                                      )
                                      : null
                                  }
                                  onChange={(opt) =>
                                    setGstForm((f) => ({
                                      ...f,
                                      gst_type_id: opt ? opt.value : "",
                                    }))
                                  }
                                  options={gstTypeOptions}
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>
                                  Party State
                                  <span className="requiredStar">*</span>
                                </Form.Label>
                                <Select
                                  classNamePrefix="react-select"
                                  placeholder="--Select State--"
                                  value={
                                    gstForm.state_id
                                      ? stateOptions.find(
                                        (o) => o.value === gstForm.state_id
                                      )
                                      : null
                                  }
                                  onChange={(opt) =>
                                    setGstForm((f) => ({
                                      ...f,
                                      state_id: opt ? opt.value : "",
                                    }))
                                  }
                                  options={stateOptions}
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>GST Reg No</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={gstForm.gst_reg_no}
                                  onChange={(e) =>
                                    setGstForm((f) => ({
                                      ...f,
                                      gst_reg_no: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>GST Reg Date</Form.Label>
                                <Form.Control
                                  type="date"
                                  value={gstForm.gst_reg_date}
                                  onChange={(e) =>
                                    setGstForm((f) => ({
                                      ...f,
                                      gst_reg_date: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Provisional Reg No</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={gstForm.prov_reg_no}
                                  onChange={(e) =>
                                    setGstForm((f) => ({
                                      ...f,
                                      prov_reg_no: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Provisional Date</Form.Label>
                                <Form.Control
                                  type="date"
                                  value={gstForm.prov_reg_date}
                                  onChange={(e) =>
                                    setGstForm((f) => ({
                                      ...f,
                                      prov_reg_date: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                        </Row>
                        <div className="mt-3 text-end">
                          <Button
                            type="button"
                            variant="secondary"
                            className="me-2"
                            onClick={clearGstForm}
                          >
                            Clear
                          </Button>
                          <Button
                            type="button"
                            variant="success"
                            className="primaryBtn"
                            onClick={handleGstSave}
                          >
                            Save
                          </Button>
                        </div>

                      </Form>
                      <div className="mt-4">
                        <div style={{ maxHeight: "200px", overflowY: "auto" }} className="sub-account-tables" >
                          <table className="table table-sm table-striped">
                            <thead>
                              <tr>
                                <th style={{ width: "40px" }}></th>
                                <th>Party State</th>
                                <th>GST Reg No</th>
                                <th>GST Reg Date</th>
                                <th>Provisional Reg Number</th>
                              </tr>
                            </thead>
                            <tbody>
                              {gstList.length === 0 && (
                                <tr>
                                  <td colSpan={5} className="text-center">
                                    No data available in table
                                  </td>
                                </tr>
                              )}
                              {gstList.map((row) => (
                                <tr key={row.sub_gst_details_id}>
                                  <td>
                                    <Button
                                      variant="link"
                                      size="sm"
                                      onClick={() => {
                                        // load row into GST form for edit
                                        setGstForm({
                                          sub_gst_details_id: row.sub_gst_details_id ?? 0,
                                          gst_type_id: row.party_gst_type_id ?? "",
                                          state_id: row.party_state_id ?? "",
                                          gst_reg_no:
                                            row.party_gst_registration_no ?? "",
                                          gst_reg_date: row.gst_registration_date
                                            ? String(row.gst_registration_date).slice(0, 10)
                                            : "",
                                          prov_reg_no:
                                            row.party_provisional_registration_no ?? "",
                                          prov_reg_date: row.provisional_registration_date
                                            ? String(row.provisional_registration_date).slice(
                                              0,
                                              10
                                            )
                                            : "",
                                        });
                                      }}
                                    >
                                      <i className="fa fa-pencil-alt" />
                                    </Button>
                                  </td>
                                  <td>{row.statename}</td>
                                  <td>{row.party_gst_registration_no}</td>
                                  <td>
                                    {row.gst_registration_date
                                      ? String(row.gst_registration_date).slice(0, 10)
                                      : ""}
                                  </td>
                                  <td>{row.party_provisional_registration_no}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>

                  )}


                  {activeTab === "Address" && (
                    <>
                      <Form>
                        <Row>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>
                                  State<span className="requiredStar">*</span>
                                </Form.Label>
                                <Select
                                  classNamePrefix="react-select"
                                  placeholder="--Select State--"
                                  value={
                                    addrForm.state_id
                                      ? stateOptions.find(
                                        (o) => o.value === addrForm.state_id
                                      )
                                      : null
                                  }
                                  onChange={async (opt) => {
                                    const val = opt ? opt.value : "";
                                    setAddrForm((f) => ({
                                      ...f,
                                      state_id: val,
                                      city_id: "",
                                    }));
                                    await fetchCitiesByState(val, setAddrCities);
                                  }}
                                  options={stateOptions}
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>
                                  City<span className="requiredStar">*</span>
                                </Form.Label>
                                <Select
                                  classNamePrefix="react-select"
                                  placeholder="--Select City--"
                                  value={
                                    addrForm.city_id
                                      ? addrCityOptions.find(
                                        (o) => o.value === addrForm.city_id
                                      )
                                      : null
                                  }
                                  onChange={(opt) =>
                                    setAddrForm((f) => ({
                                      ...f,
                                      city_id: opt ? opt.value : "",
                                    }))
                                  }
                                  options={addrCityOptions}
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Address1</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={addrForm.address1}
                                   maxLength={30}
                                  onChange={(e) =>
                                    setAddrForm((f) => ({
                                      ...f,
                                      address1: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Address2</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={addrForm.address2}
                                   maxLength={30}
                                  onChange={(e) =>
                                    setAddrForm((f) => ({
                                      ...f,
                                      address2: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Address3</Form.Label>
                                <Form.Control
                                  type="text"
                                   maxLength={30}
                                  value={addrForm.address3}
                                  onChange={(e) =>
                                    setAddrForm((f) => ({
                                      ...f,
                                      address3: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Pin Code</Form.Label>
                                <Form.Control
                                  type="text"
                                    maxLength={6}
                                  value={addrForm.pincode}
                                  onChange={(e) =>
                                    setAddrForm((f) => ({
                                      ...f,
                                      pincode: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Contact1</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={addrForm.contact1}
                                    maxLength={15}
                                  onChange={(e) =>
                                    setAddrForm((f) => ({
                                      ...f,
                                      contact1: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Contact2</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={addrForm.contact2}
                                    maxLength={15}
                                  onChange={(e) =>
                                    setAddrForm((f) => ({
                                      ...f,
                                      contact2: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                  type="email"
                                  value={addrForm.email}
                                    maxLength={75}
                                  onChange={(e) =>
                                    setAddrForm((f) => ({
                                      ...f,
                                      email: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Contact Person1 (Name)</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={addrForm.contact_person1}
                                   maxLength={100}
                                  onChange={(e) =>
                                    setAddrForm((f) => ({
                                      ...f,
                                      contact_person1: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Contact Person2 (Name)</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={addrForm.contact_person2}
                                   maxLength={100}
                                  onChange={(e) =>
                                    setAddrForm((f) => ({
                                      ...f,
                                      contact_person2: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                        </Row>
                        <div className="mt-3 text-end">
                          <Button
                            type="button"
                            variant="secondary"
                            className="me-2"
                            onClick={clearAddrForm}
                          >
                            Clear
                          </Button>
                          <Button
                            type="button"
                            variant="success"
                            className="primaryBtn"
                            onClick={handleAddressSave}
                          >
                            Save
                          </Button>
                        </div>

                      </Form>
                      <div className="mt-4">
                        <div style={{ maxHeight: "200px", overflowY: "auto" }} className="sub-account-tables" >
                          <table className="table table-sm table-striped">
                            <thead>
                              <tr>
                                <th style={{ width: "40px" }}></th>
                                <th>State</th>
                                <th>City</th>
                                <th>Address1</th>
                                <th>Contact1</th>
                                <th>ContactPerson1</th>
                              </tr>
                            </thead>
                            <tbody>
                              {addrList.length === 0 && (
                                <tr>
                                  <td colSpan={6} className="text-center">
                                    No data available in table
                                  </td>
                                </tr>
                              )}
                              {addrList.map((row) => (
                                <tr key={row.sub_address_details_id}>
                                  <td>
                                    <Button
                                      variant="link"
                                      size="sm"
                                      onClick={async () => {
                                        setAddrForm({
                                          sub_address_details_id: row.sub_address_details_id ?? 0,
                                          state_id: row.state_id ?? "",
                                          city_id: row.city_id ?? "",
                                          address1: row.address1 ?? "",
                                          address2: row.address2 ?? "",
                                          address3: row.address3 ?? "",
                                          pincode: row.pincode ?? "",
                                          contact1: row.contact_person1 ?? "",
                                          contact2: row.contact_person2 ?? "",
                                          email: row.email ?? "",
                                          contact_person1: row.contact_person_name1 ?? "",
                                          contact_person2: row.contact_person_name2 ?? "",
                                        });
                                        if (row.state_id) {
                                          await fetchCitiesByState(row.state_id, setAddrCities);
                                        }
                                      }}
                                    >
                                      <i className="fa fa-pencil-alt" />
                                    </Button>
                                  </td>
                                  <td>{row.statename}</td>
                                  <td>{row.cityname}</td>
                                  <td>{row.address1}</td>
                                  <td>{row.contact_person1}</td>
                                  <td>{row.contact_person_name1}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}

                  {activeTab === "GST Scheme" && (
                    <>
                      <Form>
                        <Row>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Scheme</Form.Label>
                                <Form.Select
                                  value={schemeForm.scheme_id}
                                  onChange={(e) =>
                                    setSchemeForm((f) => ({
                                      ...f,
                                      scheme_id: e.target.value,
                                    }))
                                  }
                                >
                                  <option value="">--Select--</option>
                                  {/* Replace with real GST Scheme options */}
                                  <option value="1">Regular</option>
                                  <option value="2">Composite</option>
                                </Form.Select>
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Effective Date From</Form.Label>
                                <Form.Control
                                  type="date"
                                  value={schemeForm.eff_from}
                                  onChange={(e) =>
                                    setSchemeForm((f) => ({
                                      ...f,
                                      eff_from: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>Effective Date To</Form.Label>
                                <Form.Control
                                  type="date"
                                  value={schemeForm.eff_to}
                                  onChange={(e) =>
                                    setSchemeForm((f) => ({
                                      ...f,
                                      eff_to: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                        </Row>
                        <div className="mt-3 text-end">
                          <Button
                            type="button"
                            variant="secondary"
                            className="me-2"
                            onClick={clearSchemeForm}
                          >
                            Clear
                          </Button>
                          <Button
                            type="button"
                            variant="success"
                            className="primaryBtn"
                            onClick={handleSchemeSave}
                          >
                            Save
                          </Button>
                        </div>

                      </Form>
                      <div className="mt-4">
                        <div style={{ maxHeight: "200px", overflowY: "auto" }} className="sub-account-tables" >
                          <table className="table table-sm table-striped">
                            <thead>
                              <tr>
                                <th style={{ width: "40px" }}></th>
                                <th>Scheme</th>
                                <th>Eff Date From</th>
                                <th>Eff Date To</th>
                              </tr>
                            </thead>
                            <tbody>
                              {schemeList.length === 0 && (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No data available in table
                                  </td>
                                </tr>
                              )}
                              {schemeList.map((row) => (
                                <tr key={row.sub_scheme_details_id}>
                                  <td>
                                    <Button
                                      variant="link"
                                      size="sm"
                                      onClick={() =>
                                        setSchemeForm({
                                          sub_scheme_details_id:
                                            row.sub_scheme_details_id ?? 0,
                                          scheme_id: row.gst_scheme_id ?? "",
                                          eff_from: row.effective_date_from
                                            ? String(row.effective_date_from).slice(0, 10)
                                            : "",
                                          eff_to: row.effective_date_to
                                            ? String(row.effective_date_to).slice(0, 10)
                                            : "",
                                        })
                                      }
                                    >
                                      <i className="fa fa-pencil-alt" />
                                    </Button>
                                  </td>
                                  <td>{row.scheme_name || "Regular"}</td>
                                  <td>
                                    {row.effective_date_from
                                      ? String(row.effective_date_from).slice(0, 10)
                                      : ""}
                                  </td>
                                  <td>
                                    {row.effective_date_to
                                      ? String(row.effective_date_to).slice(0, 10)
                                      : ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}

                  {activeTab === "TCS" && (
                    <>
                      <Form>
                        <Row>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>
                                  State<span className="requiredStar">*</span>
                                </Form.Label>
                                <Select
                                  classNamePrefix="react-select"
                                  placeholder="--Select State--"
                                  value={
                                    tcsForm.state_id
                                      ? stateOptions.find(
                                        (o) => o.value === tcsForm.state_id
                                      )
                                      : null
                                  }
                                  onChange={async (opt) => {
                                    const val = opt ? opt.value : "";
                                    setTcsForm((f) => ({
                                      ...f,
                                      state_id: val,
                                      city_id: "",
                                    }));
                                    await fetchCitiesByState(val, setTcsCities);
                                  }}
                                  options={stateOptions}
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>
                                  City<span className="requiredStar">*</span>
                                </Form.Label>
                                <Select
                                  classNamePrefix="react-select"
                                  placeholder="--Select City--"
                                  value={
                                    tcsForm.city_id
                                      ? tcsCityOptions.find(
                                        (o) => o.value === tcsForm.city_id
                                      )
                                      : null
                                  }
                                  onChange={(opt) =>
                                    setTcsForm((f) => ({
                                      ...f,
                                      city_id: opt ? opt.value : "",
                                    }))
                                  }
                                  options={tcsCityOptions}
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>
                                  TCS<span className="requiredStar">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={tcsForm.tcs_no}
                                  onChange={(e) =>
                                    setTcsForm((f) => ({
                                      ...f,
                                      tcs_no: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <div className="commonInput">
                              <Form.Group>
                                <Form.Label>
                                  TCS Date
                                  <span className="requiredStar">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="date"
                                  value={tcsForm.tcs_date}
                                  onChange={(e) =>
                                    setTcsForm((f) => ({
                                      ...f,
                                      tcs_date: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            </div>
                          </Col>
                        </Row>
                        <div className="mt-3 text-end">
                          <Button
                            type="button"
                            variant="secondary"
                            className="me-2"
                            onClick={clearTcsForm}
                          >
                            Clear
                          </Button>
                          <Button
                            type="button"
                            variant="success"
                            className="primaryBtn"
                            onClick={handleTcsSave}
                          >
                            Save
                          </Button>
                        </div>

                      </Form>
                      <div className="mt-4">
                        <div style={{ maxHeight: "200px", overflowY: "auto" }} className="sub-account-tables" >
                          <table className="table table-sm table-striped">
                            <thead>
                              <tr>
                                <th style={{ width: "40px" }}></th>
                                <th>State</th>
                                <th>City</th>
                                <th>TCS No.</th>
                                <th>TCS Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {tcsList.length === 0 && (
                                <tr>
                                  <td colSpan={5} className="text-center">
                                    No data available in table
                                  </td>
                                </tr>
                              )}
                              {tcsList.map((row) => (
                                <tr key={row.sub_tcs_details_id}>
                                  <td>
                                    <Button
                                      variant="link"
                                      size="sm"
                                      className="p-0 text-primary"
                                      onClick={async () => {
                                        setTcsForm({
                                          sub_tcs_details_id: row.sub_tcs_details_id ?? 0,
                                          state_id: row.state_id ?? "",
                                          city_id: row.city_id ?? "",
                                          tcs_no: row.tcs_no ?? "",
                                          tcs_date: row.tcs_date
                                            ? String(row.tcs_date).slice(0, 10)
                                            : "",
                                        });
                                        if (row.state_id) {
                                          await fetchCitiesByState(row.state_id, setTcsCities);
                                        }
                                      }}
                                    >
                                      <i className="fa fa-pencil-alt" />


                                    </Button>
                                  </td>
                                  <td>{row.statename}</td>
                                  <td>{row.cityname}</td>
                                  <td>{row.tcs_no}</td>
                                  <td>
                                    {row.tcs_date ? String(row.tcs_date).slice(0, 10) : ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div >
  );
}

export default AddSubAccountMaster;
